module.exports = __webpack_public_path__ + "img/erin-patterson12.2d7451d0.png";